const AdtActions = {
    SEARCH: "adt/search",
    SEARCH_RESULT: "adt/search-result",
    SEARCH_ERROR: "adt/search-error",
};

export default AdtActions;



// WEBPACK FOOTER //
// ./app/data/AdtActions.js